import { Formik } from "formik";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import FormDisplay from "./FormDisplay";
import pages from "../../../constants/pages";
import { useAxios, useAlert } from "../../../hooks";
import { signInMember } from "../../../redux/slices/memberSlice";
import { logInDetailsObject, validationSchema } from "./logInDetailsObject";
import { verifyRoleFromSignature } from "../../../utils/encryptHash";

export default function Form() {
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const axios = useAxios({ disableAuthToken: true });

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={logInDetailsObject}
        validationSchema={validationSchema}
        validateOnMount
        onSubmit={(formData, { setSubmitting }) => {
          axios({
            url: "/auth/login",
            method: "POST",
            disableRedirect: true,
            data: {
              email: formData.email,
              password: formData.password,
            },
          })
            .then(async (response) => {
              if (response.status) {
                getStateData(response, setSubmitting);
              } else {
                dispatch(
                  alert({
                    type: "error",
                    message: response.message,
                  })
                );
              }

              setSubmitting(false);
            })
            .catch((err) => {
              console.error(err);
            });
          setSubmitting(false);
        }}
      >
        {(formikProps) => (
          <form onSubmit={formikProps.handleSubmit}>
            <FormDisplay formikProps={formikProps} />
          </form>
        )}
      </Formik>
    </Fragment>
  );

  async function getStateData(response) {
    const data = response.data;

    const role = await verifyRoleFromSignature(
      response.data?.user[0]?.account_type,
      data.user[0]?.user_id
    );

    const timeStamp = new Date(data?.expiresIn).getTime();
    localStorage.setItem("expirySession", timeStamp);

    if (data.user[0]?.is_parent_brand_verified === 2) {
      dispatch(
        alert({
          type: "warning",
          message:
            "Your brand has been rejected by the admin. Please contact the admin for further details.",
        })
      );
      return;
    }
    if (role === "NORMAL_USER") {
      sessionStorage.setItem("ladder", JSON.stringify(data?.steps));
      sessionStorage.setItem("userID", parseInt(data.user[0]?.user_id));
      sessionStorage.setItem("authToken", data.token);
      sessionStorage.setItem(
        "businessEntityId",
        data.user[0]?.business_entity_id
      );

      sessionStorage.setItem("brandID", response.data.brands[0]?.brand_id);

      if (!data.steps.step2 || !data.steps.step3) {
        navigate(pages.createWelcomePage.route);
      }

      if (data.steps.step2 && data.steps.step3) {
        if (data.user[0]?.is_parent_brand_verified === 0) {
          navigate(pages.createWelcomePage.route);
        } else if (!data.user[0]?.is_admin_verified) {
          navigate(pages.createWelcomePage.route);
        } else {
          if (data.brands[0].brand_type_id === 2) {
            sessionStorage.setItem("parentName", "Audience");
            sessionStorage.setItem("subParentName", "");

            localStorage.setItem(
              "dashboardState" + response.data.brands[0]?.brand_id,
              "monetization"
            );
          }

          if (data.brands[0].brand_type_id === 3) {
            sessionStorage.setItem("parentName", "Campaigns-request");
            sessionStorage.setItem("subParentName", "");
            localStorage.setItem(
              "dashboardState" + response.data.brands[0]?.brand_id,
              "promotion"
            );
          }

          sessionStorage.setItem(
            "activeBrand",
            response.data.brands[0]?.brand_id
          );
          sessionStorage.setItem("brandType", data.brands[0].brand_type_id);

          await signInMember({
            authToken: data.token,
            userID: data.user[0]?.user_id,
            businessEntityId: data.user[0]?.business_entity_id,
            brandType: data.brands[0].brand_type_id,
          });

          if (data.brands[0].brand_type_id === 2) {
            navigate(pages.audienceList.route);
          }

          if (data.brands[0].brand_type_id === 3) {
            navigate(pages.campaignRequest.route);
          }
        }
      }
    }

    if (role === "AGENCY") {
      sessionStorage.setItem("ladder", JSON.stringify(data?.steps));
      sessionStorage.setItem("userID", parseInt(data.user[0]?.user_id));
      sessionStorage.setItem("authToken", data.token);
      sessionStorage.setItem(
        "businessEntityId",
        data.user[0]?.business_entity_id
      );

      sessionStorage.setItem("agencyID", data?.agency[0]?.agency_id);

      if (!data.steps.step2 || !data.steps.step3) {
        navigate(pages.welcomeAsAgencyPage.route);
      }

      if (data.steps.step2 && data.steps.step3) {
        if (
          !data.user[0]?.is_admin_verified ||
          data.agency[0].is_agency_verified === 0
        ) {
          navigate(pages.welcomeAsAgencyPage.route);
        } else if (data.brands.length === 0) {
          navigate(pages.welcomePage.route);
        } else {
          navigate(pages.welcomePage.route);
        }
      }
    }

    if (role === "SUPER_ADMIN") {
      await dispatch(
        signInMember({
          authToken: data.token,
          userID: parseInt(data.user[0]?.user_id),
          businessEntityId: parseInt(data.user[0]?.business_entity_id),
        })
      );
      navigate(pages.accountVerification.route);
    }

    //create new brand or company

    dispatch(
      alert({
        type: "success",
        message: response.message.displayMessage,
      })
    );
  }
}
